import { render, staticRenderFns } from "./darkzone.vue?vue&type=template&id=1a10ab3e&"
import script from "./darkzone.vue?vue&type=script&lang=js&"
export * from "./darkzone.vue?vue&type=script&lang=js&"
import style0 from "./darkzone.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports